// Notas dos senhorios guardadas localmente para aparecerem logo, sem esperar pelo elastic.
// Uma entrada com mais de 5 minutos é ignorada e apagada ao entrar na lista de senhorios.
const CACHE_KEY = "landlords_notes_cache";
const CACHE_TTL = 5 * 60 * 1000;

const readCache = () => {
    try {
        return JSON.parse(localStorage.getItem(CACHE_KEY) || "{}") || {};
    } catch (e) {
        return {};
    }
}

const writeCache = (cache) => {
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    } catch (e) {
        console.warn("Error saving landlord notes cache", e);
    }
}

const isFresh = (entry) => !!entry && entry.date > Date.now() - CACHE_TTL;

export const getCachedNotes = (landlord) => {
    let entry = readCache()[landlord.id];
    return isFresh(entry) ? entry.notes : landlord.notes;
}

export const setCachedNotes = (landlord_id, notes) => {
    let cache = readCache();
    cache[landlord_id] = {notes, date: Date.now()};
    writeCache(cache);
}

// só apaga se a entrada ainda for a destas notas, para não perder o que foi escrito entretanto
export const removeCachedNotes = (landlord_id, notes) => {
    let cache = readCache();
    if (!cache[landlord_id] || cache[landlord_id].notes !== notes) return;
    delete cache[landlord_id];
    writeCache(cache);
}

export const pruneNotesCache = () => {
    let cache = readCache();
    Object.keys(cache).forEach(landlord_id => {
        if (!isFresh(cache[landlord_id])) delete cache[landlord_id];
    });
    writeCache(cache);
}
